import { SuperbetRouteConfig } from '@superbet-group/web.types';

import { Product } from '@app/router/products/Product';
import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { Title } from '@app/router/constants/Title';
import { defaultLayout } from '@app/router/utils';
import OfferRedirects from '@pages/OfferRedirects.vue';

export const offerRedirectRoutes: SuperbetRouteConfig[] = [
    {
        path: Link.Sport.EventRedirect,
        name: RouteName.Sport.EventRedirect,
        isAccessible: Product.Sport,
        components: {
            ...defaultLayout,
            content: OfferRedirects,
        },
        meta: {
            title: Title.Sport.EventRedirect,
        },
    },
    {
        path: Link.Sport.TournamentRedirect,
        name: RouteName.Sport.TournamentRedirect,
        isAccessible: Product.Sport,
        components: {
            ...defaultLayout,
            content: OfferRedirects,
        },
        meta: {
            title: Title.Sport.TournamentRedirect,
        },
    },
    {
        path: Link.Sport.CategoryRedirect,
        name: RouteName.Sport.CategoryRedirect,
        isAccessible: Product.Sport,
        components: {
            ...defaultLayout,
            content: OfferRedirects,
        },
        meta: {
            title: Title.Sport.CategoryRedirect,
        },
    },
];
